import { render, staticRenderFns } from "./UnitAttributesComponent.vue?vue&type=template&id=14bb20fa&"
import script from "./UnitAttributesComponent.vue?vue&type=script&lang=js&"
export * from "./UnitAttributesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports